// https://vuex.vuejs.org/en/mutations.html
import state from "./state";
import videoChat from "./modules/videoChat";

function remove(array, element) {
  const index = array.indexOf(element);

  if (index !== -1) {
    array.splice(index, 1);
  }
}

function last_message(item) {
  let ls = "";
  if (typeof item === "object") {
    if (Object.keys(item).includes("carousel") && item.carousel)
      ls = { key: "Carousel" };
    else if (Object.keys(item).includes("attachment") && item.attachment)
      ls = { key: "Attachment" };
    else if (Object.keys(item).includes("look") && item.look)
      ls = { key: "Look" };
    else if (Object.keys(item).includes("form") && item.form)
      ls = `From of ${item.message.split(".")[0]}`;
    else if (Object.keys(item).includes("buttons") && item.buttons)
      ls = `${item.message.split(".")[0]} Selection`;
    else if (Object.keys(item).includes("grid") && item.grid)
      ls = { key: "Grid" };
    else if (Object.keys(item).includes("brands") && item.brands)
      ls = { key: "Brands" };
    else ls = item.message;
  } else ls = item;
  return ls;
}

function status_set(status) {
  if (status === "Solved") {
    return { color: "#008000", value: "Solved" };
  } else if (status === "Solved (Email)") {
    return { color: "#008000", value: "Solved (Email)" };
  } else if (status === "To check") {
    return { color: "error darken-1", value: "To check" };
  } else if (status === "To check sto") {
    return { color: "error darken-1", value: "To check sto" };
  } else if (status === "By email") {
    return { color: "red darken-2", value: "By email" };
  } else if (status === "Answered") {
    return { color: "#65ff00", value: "Answered" };
  } else if (status === "To answer") {
    return { color: "red darken-1", value: "To answer" };
  }
}

function Email_status_filter(st) {
  if (st === "Answered") {
    return { color: "#65ff00", value: "Answered" };
  } else if (st === "Transferred - CS") {
    return { color: "warning", value: "Transferred - CS" };
  } else if (st === "Transferred - Sto") {
    return { color: "warning", value: "Transferred - Sto" };
  } else if (st === "Answered_Relancé") {
    return { color: "#008000", value: "Answered_Relancé" };
  } else if (st === "To answer") {
    return { color: "red darken-1", value: "To answer" };
  } else if (st === "Purchase") {
    return { color: "#008000", value: "Purchase" };
  } else return { color: "grey", value: "none" };
}

function PushMessages(state, newMsg, dispatch) {
  const index = state.messages.all_messages.findIndex(
    (x) => x.guid === newMsg.guid
  );
  if (index >= 0) {
    state.messages.all_messages[index] = newMsg;
    const temp = state.messages.all_messages[index];
    remove(state.messages.all_messages, temp);
    state.messages.all_messages.splice(0, 0, temp);
  } else state.messages.all_messages.unshift(newMsg);

  if (state.messages.sorts.selected_sort) {
    dispatch("filter_date", state.messages.sorts.selected_sort);
    dispatch("filter_bools", state.messages.sorts.selected_sort);
    dispatch("filter_status", state.messages.sorts.selected_sort);
  }
  if (state.messages.sorts.conversation.filter_by === "show_conversations") {
    dispatch(
      "filter_conversation",
      state.messages.sorts.conversation.filter_by
    );
  }
}

function notifyMe(dispatch, text, data, msg) {
  let title = "";
  let options = {};

  if (msg) {
    title = "Cleed admin Notifications:";
    options = {
      body: text,
      data: data,
      requireInteraction: true,
    };
  } else {
    title = "Cleed admin Notifications:";
    options = {
      body: text,
      data: data,
      requireInteraction: false,
    };
  }

  // Let's check if the browser supports notifications
  if (!("Notification" in window)) {
    alert("This browser does not support desktop notification");
  }

  // Let's check whether notification permissions have already been granted
  else if (Notification.permission === "granted") {
    // If it's okay let's create a notification
    let showNotification = document.visibilityState !== "visible";
    if (showNotification) {
      var notification = new Notification(title, options);
      if (options.data) {
        notification.onclick = function (event) {
          window.focus();
          dispatch("route_push_toMsg");
        };
      }
    }
  }

  // Otherwise, we need to ask the user for permission
  else if (Notification.permission !== "denied") {
    Notification.requestPermission().then(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        var notification = new Notification(text);
      }
    });
  }

  // At last, if the user has denied notifications, and you
  // want to be respectful there is no need to bother them any more.
}

export default {
  SET_ACCESS_OPENAI_CONFIG(state, value) {
    state.access_openai_config = value;
  },

  SET_EMOJI_HISTORY(state, emojiHistory) {
    state.emojiHistory = emojiHistory;
  },
  SET_SNACKBAR(state, snackbar) {
    state.snackbar = snackbar;
  },
  SET_AddToCard(state, AddToCard) {
    state.AddToCard = AddToCard;
  },
  SET_PurchaseProducts(state, PurchaseProducts) {
    state.PurchaseProducts = PurchaseProducts;
  },
  SET_ATTACHBOX(state, AttachBox) {
    state.AttachBox = AttachBox;
  },
  SET_EMAILDETETC(state, EmailDetectBox) {
    state.EmailDetectBox = EmailDetectBox;
  },
  SET_LOADER(state, loading) {
    state.loading = loading;
  },
  SET_C_LOADER(state, Cloader) {
    state.Cloader = Cloader;
  },
  SET_NOTIF(state, notification) {
    state.notifications = notification;
  },
  SET_INFOCARD(state, infocard) {
    state.infocard = infocard;
  },
  SET_MESSAGES: (state, messages) => {
    state.messages.messages = messages;
  },
  SET_SYSTEM_EXPORT: (state, showing) => {
    state.system_export.showing = showing;
  },
  SOCKET_SET_PHONE_NUMBER(state, { guid, phone_number }) {
    console.log("call_phone_set", phone_number, guid);
    // set the phone number to the user class mutation
    const index = state.messages.filter_rest.findIndex((x) => x.guid === guid);
    if (index >= 0) {
      //set phone number in messanger dash
      state.messages.filter_rest[index].contact = phone_number;
      state.messages.filter_rest[index].phone_number = phone_number;
    }
    if (state.user.users[guid]) {
      //set in data users
      state.user.users[guid].phone_number = phone_number;
    }
    console.log("call_phone_set", phone_number, state.user.users[guid]);
  },
  SOCKET_SETEMAIL(state, { data, user }) {
    // set the email to the user class mutation
    const index = state.messages.filter_rest.findIndex(
      (x) => x.guid === user.guid
    );
    if (index >= 0) {
      //set email in messanger dash
      state.messages.filter_rest[index].contact = data.email;
      state.messages.filter_rest[index].email = data.email;
    }
    if (state.user.users[user.guid]) {
      //set in data users
      state.user.users[user.guid].email = data.email;
    }

    console.log("call_email", data, state.user.users[user.guid]);
  },
  SOCKET_ADMIN_DELETE_ACTION(state, data) {
    for (let i = 0; i < data.selected.length; i++) {
      // delete in filter messages array
      const index1 = state.messages.filter_rest.findIndex(
        (x) => x.i_msg === data.selected[i]
      );
      // delete notification number
      if (index1 >= 0) {
        if (state.notification.users[state.messages.filter_rest[index1].guid]) {
          state.notification.notif =
            state.notification.notif -
            state.notification.users[state.messages.filter_rest[index1].guid];
          delete state.notification.users[
            state.messages.filter_rest[index1].guid
          ];
        }
        state.messages.filter_rest.splice(index1, 1);
      }

      // delete in all messages array
      const index2 = state.messages.all_messages.findIndex(
        (x) => x.i_msg === data.selected[i]
      );
      if (index2 >= 0) state.messages.all_messages.splice(index2, 1);
    }
  },
  SOCKET_ADMIN_UPDATE_ACTION(state, data) {
    if (data.from === "status") {
      const index = state.messages.filter_rest.findIndex(
        (x) => x.id_c === data.data.id
      );
      if (index >= 0) {
        state.messages.filter_rest[index].statusObj = data.data.status_obj;
        state.messages.filter_rest[index].status = data.data.status;
        // remove the message if filter != the status change  in live socket
        if (state.messages.sorts.selected_sort === "status") {
          if (
            !state.messages.sorts[
              state.messages.sorts.selected_sort
            ].filter_by.includes(data.data.status)
          )
            state.messages.filter_rest.splice(index, 1);
        }
      }
      // else {
      //   //if the messsge status change and one of the admin is using the filters
      //   const index1 = state.messages.all_messages.findIndex(
      //     (x) => x.i_msg === data.data.msg_id
      //   );
      //   if (index1 >= 0) {
      //     state.messages.all_messages[index1].statusObj = data.data.status_obj;
      //     state.messages.all_messages[index1].status = data.data.status;
      //     if (state.messages.sorts.selected_sort === "status") {
      //       if (
      //         state.messages.sorts[
      //           state.messages.sorts.selected_sort
      //         ].filter_by.includes(data.data.status)
      //       )
      //         state.messages.filter_rest.unshift(
      //           state.messages.all_messages[index1]
      //         );
      //     }
      //   }
      // }
    } else if (data.from === "priority") {
      const index = state.messages.filter_rest.findIndex(
        (x) => x.i_msg === data.data.msg_id
      );
      if (index >= 0) {
        state.messages.filter_rest[index].priority = !state.messages
          .filter_rest[index].priority;
        // remove the message if filter != the status change  in live socket
        if (state.messages.sorts.selected_sort === "priority") {
          state.messages.filter_rest.splice(index, 1);
        }
      } else {
        //if the messsge status change and one of the admin is using the filters
        const index1 = state.messages.all_messages.findIndex(
          (x) => x.i_msg === data.data.msg_id
        );
        if (index1 >= 0) {
          state.messages.all_messages[index1].priority = !state.messages
            .all_messages[index1].priority;
          if (state.messages.sorts.selected_sort === "priority") {
            state.messages.filter_rest.unshift(
              state.messages.all_messages[index1]
            );
          }
        }
      }
    } else if (data.from === "note") {
      const index = state.messages.filter_rest.findIndex(
        (x) => x.i_msg === data.data.msg_id
      );
      if (index >= 0) {
        state.messages.filter_rest[index].AdminNote = data.data.text;
      }
    } else if (data.from === "e_status") {
      const index = state.messages.filter_rest.findIndex(
        (x) => x.i_msg === data.data.msg_id
      );
      if (index >= 0) {
        state.messages.filter_rest[index].EmailStatusObj = data.data.status_obj;
        state.messages.filter_rest[index].email_status = data.data.e_status;
        // remove the message if filter != the status change  in live socket
        if (state.messages.sorts.selected_sort === "status_email") {
          if (
            !state.messages.sorts[
              state.messages.sorts.selected_sort
            ].filter_by.includes(data.data.e_status)
          )
            state.messages.filter_rest.splice(index, 1);
        }
      } else {
        //if the messsge status change and one of the admin is using the filters
        const index1 = state.messages.all_messages.findIndex(
          (x) => x.i_msg === data.data.msg_id
        );
        if (index1 >= 0) {
          state.messages.all_messages[index1].EmailStatusObj =
            data.data.status_obj;
          state.messages.all_messages[index1].email_status = data.data.e_status;
          if (state.messages.sorts.selected_sort === "status_email") {
            if (
              state.messages.sorts[
                state.messages.sorts.selected_sort
              ].filter_by.includes(data.data.e_status)
            )
              state.messages.filter_rest.unshift(
                state.messages.all_messages[index1]
              );
          }
        }
      }
    } else if (data.from === "agent") {
      const index = state.messages.all_messages.findIndex(
        (x) => x.i_msg === data.data.msg_id
      );
      if (index >= 0) {
        state.messages.all_messages[index].agent = data.data.agent;
      }
    }
  },
  SOCKET_newMessage(state, data) {
    // console.log('here1')
    const At = Date.now();
    let obj = {
      user_id: data.user.id,
      id_msg: data.i_msg,
      content: data.content,
      sender_type: "admin",
      send_time: At,
      id_c: data.conversation_id,
      status: data.status,
      email_status: data.email_status,
    };
    state.messages.messages.push(obj);
    console.log(state.messages.messages, data);
    const index = state.messages.filter_rest.findIndex(
      (x) => x.guid === data.user.guid
    );
    if (index >= 0) {
      state.messages.filter_rest[index].status = data.status;
      state.messages.filter_rest[index].statusObj = status_set(data.status);
    }
    state.real_timeMessages.localMsg.push(obj);
  },
  SOCKET_message_from_slack(state, data) {
    const At = new Date();
    console.log("call message_from_slack", data);
    const index = state.messages.filter_rest.findIndex(
      (x) => x.guid === data.user.guid
    );
    if (state.show.dash) {
      if (index >= 0) {
        state.messages.filter_rest[index].last_message = data.message;
        if (state.messages.filter_rest[index].status === "To answer") {
          state.messages.filter_rest[index].status = "Answered";
          state.messages.filter_rest[index].statusObj = status_set("Answered");
        }
        const d = (new Date() + "").split(" ");
        const tmp = [d[2], d[1], d[3], d[4]].join(" ");
        const res = tmp.split(":");
        state.messages.filter_rest[index].sent_at_value = `${res[0]}:${res[1]}`;
      }
    } else {
      let obj = {
        user_id: data.user.id,
        guid: data.user.guid,
        id_msg: data.id_msg,
        ts_slack: data.user.channel,
        content: data.message,
        sender_type: "admin",
        send_time: At,
        id_c: state.messages.filter_rest[index].conversation_id,
        status: state.messages.filter_rest[index].status,
        email_status: state.messages.filter_rest[index].email_status,
      };
      console.log(obj);
      state.messages.messages.push(obj);
    }
  },
  reciveMessage(state, data) {
    //console.log("reciveMessage |>", state.store.store.store_id, data);
    const At = new Date();
    if (state.chat_user.guid === data.user.guid) {
      let obj = {
        id: state.user.users[data.user.guid].id,
        id_msg: state.user.users[data.user.guid].id_msg,
        content: data.user.msg,
        sender_type: data.user.sender || "self",
        sent_at: At.toISOString(),
        status: data.user.status,
        email_status: data.user.email_status,
        current_url: data.user.url,
        context: data?.user?.context,
      };

      if (data?.user?.llmLogs) {
        const llm_log = {
          message_log_id: "-",
          message_log_content: data?.user?.llmLogs,
          message_log_created_at: At.toISOString(),
          message_log_event_type: "llm",
          message_log_source: "info",
          message_log_metadata: {
            user_id: data?.user?.llmLogs?.metadata?.user_id,
            store_id: data?.user?.llmLogs?.metadata?.store_id,
          },
        };
        obj = { ...obj, ...llm_log };
      }
      state.messages.messages.push(obj);
      const index = state.messages.filter_rest.findIndex(
        (x) => x.guid === data.user.guid
      );
      if (index >= 0) {
        state.messages.filter_rest[index].status = data.user.status;
        state.messages.filter_rest[index].statusObj = status_set(
          data.user.status
        );
      }
      state.real_timeMessages.other.push(obj);
    }
  },
  SOCKET_Online(state, data) {
    if (state.store.store.store_id === data.store) {
      if (!state.online_users.includes(data.user.guid.toString())) {
        state.online_users.push(data.user.guid);
        if (!state.user.users[data.user.guid])
          state.user.users[data.user.guid] = data.user;
        //console.log("emit online", state.user.users[data.user.guid]);
      }
    }
  },
  SOCKET_Offline(state, data) {
    remove(state.online_users, data);
  },
  SOCKET_CheckOnline(state, data) {
    state.online_users = data;
  },
  SOCKET_TypingTracker(state, { data, user }) {
    if (state.chat_user && state.chat_user.guid == user.guid) {
      state.show.UserWritingDots = data.state == "focus" ? true : false;
    }
  },
  MsgNotification(state, { data, rootState }) {
    //console.log("MsgNotification |>", state.store.store.store_id, data);
    if (state.store.store.store_id === data.store) {
      // if (state.link.to !== "/messages") {
      //   state.notification.notif = state.notification.notif
      //     ? state.notification.notif + 1
      //     : 1;
      //   state.notification.users[data.user.guid] = state.notification.users[
      //     data.user.guid
      //   ]
      //     ? state.notification.users[data.user.guid] + 1
      //     : 1;
      // }
      let name;
      if (state.user.users[data.user.guid])
        name = `New message from '${
          state.user.users[data.user.guid].firstname ||
          state.user.users[data.user.guid].email ||
          `#${state.user.users[data.user.guid].id}`
        }' !`;
      /**------------  nnotifications: ----------------- */
      // notify just user message (do not show notification for bot messages)  +  eliminame the fist one
      if (
        state.messages.NotificationPush &&
        data.user.sender !== "bot" &&
        !data.user.is_first_proposition
      ) {
        let notify_check = true;

        // notifiy sut th estatus filter by the admin
        console.log(
          "messages.sorts --->",
          state.messages.sorts.selected_sort,
          state.messages.sorts.status.filter_by
        );
        if (state.messages.sorts.selected_sort === "status") {
          if (state.messages.sorts.status.filter_by.includes(data.user.status))
            notify_check = true;
          else notify_check = false;
        }
        if (data?.user?.mode == "whatsapp_mode") {
          const selectedContext =
            rootState.messangerItems[rootState.messanger_type_selected]?.mode ||
            undefined;
          notify_check = selectedContext != "whatsapp_mode" ? true : false;
          data.user.msg_from_part = "chat";
        }
        //////////////////////////////////////////

        if (notify_check && data.user.msg_from_part === "chat") {
          console.log("notify", data);
          notifyMe(this.dispatch, name, data.user, true);
          let mode_icon = "messenger-notification";
          const index = rootState.messangerItems.findIndex(
            (x) => x.mode === data.user.mode
          );
          console.log({ index });
          if (index > -1 && rootState.messangerItems[index]?.icon) {
            mode_icon = rootState.messangerItems[index].icon;
          }
          this.dispatch("setNotification", {
            status: status_set(data.user.status).value,
            email_status: data.user.email_status,
            showing: true,
            text: name,
            position: "top-right",
            type: "success",
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.5,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: false,
            rtl: false,
            mode_icon,
          });

          // play sounds
          const audio = new Audio(
            "https://storage.googleapis.com/cleed-datacenter-europe/packages/lib/notification-sound1.ogg"
          );

          audio.volume = 0.1;
          audio.play();
        }
      }
      /**------------  end nnotifications----------------- */

      //add the date sent looks in Messages-dash
      function date_form(date) {
        const d = (new Date(date.sent_at) + "").split(" ");
        const tmp = [d[2], d[1], d[3], d[4]].join(" ");
        const res = tmp.split(":");
        date.sent_at_value = `${res[0]}:${res[1]}`;
      }

      const selectedContext =
        rootState.messangerItems[rootState.messanger_type_selected]?.mode ||
        undefined;
      if (
        !selectedContext ||
        selectedContext === "all" ||
        data.user.mode === selectedContext
      ) {
        let newMsg = {};

        newMsg = {
          // the info of this object must be in client side
          AdminNote: "",
          last_message: data.user.msg,
          contact: `${
            state.user.users[data.user.guid].firstname ||
            state.user.users[data.user.guid].email ||
            `#${state.user.users[data.user.guid].id}`
          }`,
          context: "chat",
          conversation_id: data.user.id_c,
          id_c: data.user.id_c,
          priority: false,
          receiver: parseInt(state.user.users[data.user.guid].id),
          receiver_id: state.user.users[data.user.guid].id,
          guid: data.user.guid,
          sender_type: data.user.sender || "self",
          sent_at: new Date(),
          statusObj: status_set(data.user.status),
          EmailStatusObj: Email_status_filter(data.user.email_status),
          waiting: `Now`,
          store_id: data.store,
          i_msg: data.user.id,
          status: data.user.status,
          email_status: data.user.email_status,
        };
        date_form(newMsg);
        PushMessages(state, newMsg, this.dispatch);
      }
    }
  },
  SOCKET_delete_message_from_slack(state, data) {
    const index = state.messages.messages.findIndex(
      (x) => x.id_msg === data.data.id_msg
    );
    if (index > -1) {
      state.messages.messages.splice(index, 1);
    }
  },
  VIDEO_SOCKET_VideoChat_newMessage(state, data) {
    const At = Date.now();
    let obj = {
      user_id: data.receiver_id,
      id_msg: data.i_msg,
      content: data.content,
      sender_type: data.sender_type,
      send_time: At,
      id_c: data.conversation_id,
      status: data.status,
      email_status: data.email_status,
      context: data.context,
      video_chat: data.video_chat,
    };
    state.messages.messages.push(obj);
    console.log(state.messages.messages, data);
    const index = state.messages.filter_rest.findIndex(
      (x) => x.guid === data.guid
    );
    if (index >= 0) {
      state.messages.filter_rest[index].status = data.status;
      state.messages.filter_rest[index].statusObj = status_set(data.status);
    }
    state.real_timeMessages.localMsg.push(obj);
  },
};
